module.exports = {
      id: "gn-reach-icon-usage",
      viewBox: "0 0 159 50",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#gn-reach-icon",
      toString: function () {
        return this.url;
      }
    }